<template>
  <div v-if="defaultCurrency">
    <div class="default-currency">
      <v-icon size="14" class="default-currency__icon">
        mdi-cash-multiple
      </v-icon>
      <span class="default-currency__caption d-none d-md-inline">
        {{ label.caption.operationalCurrency }}
      </span>
      <span class="default-currency__value">
        {{ defaultCurrency.text }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import label from "@/lang/StaticLabels.js";

export default {
  name: "DefaultCurrency",
  data() {
    return {
      label,
    };
  },
  computed: {
    ...mapGetters({
      currencyTypeOptions: "dropdownX/currencyTypeOptions",
    }),
    defaultCurrency() {
      return this.currencyTypeOptions.find((z) => z.isDefault);
    },
  },
  mounted() {
    if (!this.currencyTypeOptions.length) {
      this.$store.dispatch("dropdownX/getCurrencyTypes");
    }
  },
};
</script>

<style scoped>
.default-currency {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 30px;
  min-width: 0;
  max-width: 100%;
  padding-inline: 8px;
  border-radius: 6px;
  cursor: default;
  user-select: none;
  border: 1px solid
    rgba(var(--color-first-r), var(--color-first-g), var(--color-first-b), 0.35);
  background-color: rgba(
    var(--color-first-r),
    var(--color-first-g),
    var(--color-first-b),
    0.04
  );
}

.default-currency__icon {
  flex: 0 0 auto;
  color: var(--color-first) !important;
}

.default-currency__caption {
  flex: 0 0 auto;
  white-space: nowrap;
  font-size: var(--font-size-xsmall);
  color: var(--color-gray);
}

.default-currency__value {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--font-size-small);
  font-weight: 600;
  color: var(--color-first);
}
</style>
